import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { API } from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const render = () => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Web demo build only (REACT_APP_DEMO=1): a stand-in server inside the page answers the screens
if (process.env.REACT_APP_DEMO === '1') {
  import('./demo/demoEngine').then(m => { m.installDemoEngine(API); render(); });
} else {
  render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
